import * as React from 'react';
import { Typography, Box, Container } from '@mui/material';
import { SectionContainer } from './Components/styles';
import ScrollAnimation from './Components/ScrollAnimation';

const audienceTitles = ['Content Creators', 'Copywriters', 'Agencies', 'Marketing', 'Freelancers'];

export default function AudienceSection() {
    return (
        <div style={{ background: 'white', backgroundImage: 'url(/bg.jpg)', boxShadow: '0 0 10px 3px #020047' }}>

            <SectionContainer>
                <ScrollAnimation animateIn="flipInX" delay={0.3}>
                    <Typography variant="h3" sx={{ fontSize: '44px', color: '#fff', fontWeight: 700, lineHeight: 1.13, letterSpacing: '-1.76px', mb: 6, padding: '0px 1px' }}>
                        A Toolkit for Creatives & Marketers: Unleash Your Potential
                    </Typography>
                    <Box sx={{
                        overflow: 'hidden', // This ensures anything outside this box is not visible
                        height: '100%', // Adjust based on your requirement
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center', // Center vertically
                        width: '100%', // This can be adjusted based on your layout
                    }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row', // Keep as a row for horizontal layout
                            gap: 5,
                            alignItems: 'center',
                            animation: 'scrollHorizontal 20s linear infinite', // Adjust duration as needed
                            padding: '20px 100px', // Adjust padding as needed
                        }}>
                            {[...Array(3)].map((_, outerIndex) => (
                                <Box key={outerIndex} sx={{ display: 'flex', flexDirection: 'row', gap: 5 }}>
                                    {audienceTitles.map((title, index) => (
                                        <Typography key={index} variant="h3" component="h3"
                                            sx={{
                                                color: 'white',
                                                fontSize: '60px',
                                                fontWeight: 700,
                                                letterSpacing: '-1.76px',
                                                textAlign: 'left',
                                                border: '2px solid white', // Adjust border as needed
                                                borderRadius: '25px',
                                                padding: '20px', // Adjust padding as needed
                                                flexShrink: 0, // Prevent the Typography from shrinking
                                                whiteSpace: 'nowrap', // Ensure the text does not wrap
                                            }}
                                        >
                                            {title}
                                        </Typography>
                                    ))}
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </ScrollAnimation>
            </SectionContainer>

        </div>
    );
}
